import {
  IServiceBlock,
  useBlocksActions,
} from '@/models/commercial-proposals/blocks.store';
import { BoxProps, Text } from '@mantine/core';
import { get, set } from 'lodash-es';
import CellBase, { cellId } from '../CellBase';
import HeadingCellSettings, { IHeadingCellConfig } from './HeadingCellSettings';

export default function HeadingCell({
  block,
  id,
  ...props
}: {
  block: IServiceBlock;
  id: string;
} & BoxProps) {
  const { update } = useBlocksActions();

  const config: IHeadingCellConfig = {
    title: '',
    subtitle: '',
    showSubtitle: false,
    ...get(block, id, {}),
  };

  return (
    <CellBase
      id={cellId({
        blockId: block.uuid,
        suffix: id,
      })}
      settings={
        <HeadingCellSettings
          config={config}
          onChange={(config) => {
            update({ ...set(block, id, config) });
          }}
        />
      }
      {...props}
    >
      <Text fw={500} size="xs" style={{ whiteSpace: 'pre' }}>
        {config.title}
      </Text>
      {config.showSubtitle && (
        <Text fw={500} size="xs" c="dimmed" style={{ whiteSpace: 'pre' }}>
          {config.subtitle}
        </Text>
      )}
    </CellBase>
  );
}
